module.exports = function(service) {
	'use strict'
	service.factory('durationFormated', durationFormated);
	durationFormated.$inject = [];
	function durationFormated() {
	    return function(duration) {
            if(!duration) return;
            var formatedTime;
            if(duration>=3600) {
                formatedTime = 'H:mm:ss'
            } else{
                formatedTime = 'm:ss'
            } 
            return moment().startOf('day').second(duration).format(formatedTime);
            
	    }
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/durationFormatedService.js
// module id = 598
// module chunks = 0